import React from "react";
import "./Button.css";

const Button = ({ children, className = "", type = "button", ...props }) => {
  return (
    <button className={className} type={type} {...props}>
      {children}
    </button>
  );
};

export default Button;
